import AboutUsComponent from "../components/AboutComponent"
import FooterComponent from "../components/FooterComponent"
import HeaderComponent from "../components/HeaderComponent"

const AboutPage = () => {
    return (
        <>
            <HeaderComponent/>
            <AboutUsComponent/>
            <FooterComponent/>
        </>
    )
}

export default AboutPage